import React from "react";
import {Avatar} from "antd";
import {CandidateIcon} from "config/icons";
import styles from '../style.module.scss'
import {MultiAccountViewProps} from "./MultiAccountView";

export const MultiAccountViewArea = (props: MultiAccountViewProps) => {
  const { email, name, onClick, src = '' } = props
    return (
      <div className={styles.accountContainerArea} onClick={onClick}>
        <div className="mr-2">
          <Avatar
            src={src}
            icon={<CandidateIcon />}
            size={35}
          />
        </div>
        <div>
          <div style={{ fontWeight: 500 }}>
            {name}
          </div>
          {email}
        </div>
      </div>
    )
}
